"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var NavButton_1 = require("./NavButton");
var Context_1 = require("../Context");
require("../Styles/DashboardNavBar.css");
var DashboardNavBar = /** @class */ (function (_super) {
    __extends(DashboardNavBar, _super);
    function DashboardNavBar(props) {
        return _super.call(this, props) || this;
    }
    DashboardNavBar.prototype.render = function () {
        var _this = this;
        return (React.createElement(Context_1.DashboardContext.Consumer, null, function (DashboardContext) {
            var _a;
            return DashboardContext && (React.createElement("div", { className: "row" },
                !_this.props.applicationData.userInfo.UserRole.match(/SuperUser/g) &&
                    React.createElement("div", { className: "col" },
                        React.createElement(NavButton_1.NavButton, { active: DashboardContext.props.match.params.path.toUpperCase() == "SAFE" /* Safe */, text: _this.props.resources.Safe, icon: free_solid_svg_icons_1.faShieldAlt, endpoint: "/Dashboard/Safe" })),
                !_this.props.applicationData.userInfo.UserRole.match(/SuperUser/g) &&
                    React.createElement("div", { className: "col" },
                        React.createElement(NavButton_1.NavButton, { active: DashboardContext.props.match.params.path.toUpperCase() == "SINGLE" /* Single */, text: _this.props.resources.Single, icon: free_solid_svg_icons_1.faPrescriptionBottleAlt, endpoint: "/Dashboard/Single" })),
                ((_this.props.applicationData.apiProvider == "Ssr" || (_this.props.applicationData.locations.length != 0 && ((_a = _this.props.applicationData.locations.find(function (x) { return x.Name == _this.props.applicationData.selectedLocation; })) === null || _a === void 0 ? void 0 : _a.Type) == "Wholesaler")) && !_this.props.applicationData.userInfo.UserRole.match(/SuperUser/g)) &&
                    React.createElement("div", { className: "col" },
                        React.createElement(NavButton_1.NavButton, { active: DashboardContext.props.match.params.path.toUpperCase() == "MULTIPLE" /* Multiple */, text: _this.props.resources.Multiple, icons: free_solid_svg_icons_1.faPrescriptionBottleAlt, endpoint: "/Dashboard/Multiple" })),
                React.createElement("div", { className: "col" },
                    React.createElement(NavButton_1.NavButton, { active: DashboardContext.props.match.params.path.toUpperCase() == "REPORTS" /* Reports */, text: _this.props.resources.Reports, icon: free_solid_svg_icons_1.faChartPie, endpoint: "/Dashboard/Reports" }))));
        }));
    };
    return DashboardNavBar;
}(React.Component));
exports.DashboardNavBar = DashboardNavBar;
//# sourceMappingURL=DashboardNavBar.js.map